import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { setOverlayValue } from 'store';
import WP from 'WP';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';

import CrossIcon from 'icons/CrossIcon';

import Media from 'css/Media';

class BookATable extends Component {

    componentDidMount() {
        window.addEventListener('touchmove',this.preventScroll, { passive: false });
    }

    clickHandler() {
        window.removeEventListener('touchmove', this.preventScroll);
        document.getElementsByTagName('html')[0].style.overflowY = 'visible';
        this.props.setOverlayValue({visible: false});
    }

    preventScroll(e) {
        return e.preventDefault();
    }

    render() {
        const { src } = this.props;

        return (
            <Wrapper>
                <Container grid>
                    <ExitGridElement
                        colStart={{default: 7, s: 23}}
                        colEnd={{default: 8, s: 24}}
                        onClick={() => this.clickHandler()}
                    >
                        <ExitButton>
                            <CrossIcon />
                        </ExitButton>
                    </ExitGridElement>
                </Container>
                <Container grid>
                    <ContentGridElement
                        colStart={{default: 1, s: 5, m: 7, l: 9}}
                        colEnd={{default: 8, s: 20, m: 18, l: 16}}
                    >
                        <h3>{WP.trans.reserveTable}</h3>
                        <iframe src={src} title="book-a-table" />
                        <CloseButton onClick={() => this.clickHandler()}>Lukk</CloseButton>
                    </ContentGridElement>
                </Container>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    overlayValue: state.overlayValue,
});

const actions = {
    setOverlayValue
}

export default connect(mapStateToProps, actions)(BookATable);


const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${props => props.theme.colors.text};
    overflow-y: scroll;
    z-index: 1000;

    .container {
        margin-bottom: 45px;
    }
`

const ExitButton = styled.button`
    cursor: pointer;
`

const ExitGridElement = styled(GridElement)`
    margin-top: 45px;
    justify-self: end;

    ${Media.greaterThan('s')`
        margin-top: 64px;
    `}
`

const ContentGridElement = styled(GridElement)`
    background-color: ${props => props.theme.colors.negative};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;

    h3 {
        text-align: center;
        line-height: 27px;
    
        ${Media.greaterThan('s')`
        `}
    }

    iframe {
        width: 320px;
        height: 380px;

        ${Media.greaterThan('s')`
            margin: ${props => props.theme.spacing.elementM} 0;
        `}
    }

    ${Media.greaterThan('s')`
        padding: ${props => props.theme.spacing.elementXS} 0 ${props => props.theme.spacing.elementM};
    `}
`

const CloseButton = styled.div`
    border: 2px solid ${props => props.theme.colors.text};
    border-radius: 50px;
    padding: 20px 60px;
    display: inline-block;
    text-align: center;
    align-self: center;
    cursor: pointer;
`
